import React from "react";
import { useTranslation } from "react-i18next";
import BreadCrumb from "components/breadcrumb";
import MainHeader from "components/header";
import ImageA from "components/main/marketing-assets/image";

const ImageAssets = () => {
  const {t, i18n} = useTranslation('common');
  const nav = [
    {
      url: "/affiliate/overview",
      label: t("general.dashboard"),
    },
    {
      url: "/affiliate/marketing-assets/social-media-assets",
      label: t("assets.marketing"),
    },
    {
      url: "/affiliate/marketing-assets/image-assets",
      label: t("assets.image"),
      main: true,
    },
  ];
  return (
    <>
      <MainHeader title={t("assets.image")} />
      <BreadCrumb links={nav} />
      <ImageA />
    </>
  );
};

export default ImageAssets;
